
import clientAuth from "../clientAuth"
export default {
    index: () => clientAuth.get(`payment/index`),

    destroy: (id) => clientAuth.delete(`payment/destroy/${id}`),

    update: (id, userData) => clientAuth.post(`payment/update/${id}`, { json: userData }),
    
    show: (id) => clientAuth.get(`payment/show/${id}`),

   

};